<template>
  <div class="student-layout">
    <Header></Header>
    <transition name="slide" mode="out-in">
      <slot></slot>
    </transition>
    <!-- Start Footer-->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from "@/components/Footer.vue";
import GlobalMixin from "@/GlobalMixin.js";

export default {
  mixins: [GlobalMixin],
  name: "student_layout",
  components: {
    Header,
    Footer
  }
};
</script>
<style scoped lang="scss"></style>
